import React from 'react'
import { FlatList } from 'react-native'

import { useRoute } from '@react-navigation/native'
import BottomSheetHeader from '@zet/common/components/bottomSheetHeader'
import { Stack } from '@zet/design-system/layout'
import { i18n } from '@zet/localization'
import { isCustomerFlow } from '@zet/utils/isCustomerFlow'

import ProductCard from '../../components/productCard'
import useInEligibleData, {
  IInEligibleBrandsListParams,
} from './useInEligibleData'

const InEligibleBrandsList = () => {
  const route = useRoute()
  const params: IInEligibleBrandsListParams =
    route.params as IInEligibleBrandsListParams
  const { inEligibleList } = useInEligibleData(params)

  return (
    <Stack className="mb-3 bg-white">
      {isCustomerFlow() && (
        <BottomSheetHeader
          isSecondaryIcon={false}
          primaryIcon="Close"
          title={i18n.t('headerInEligibleBrands', {
            count: inEligibleList?.length,
          })}
          isGoBack={true}
        />
      )}
      <FlatList
        data={inEligibleList}
        keyExtractor={(item) => item?.partnerId}
        showsVerticalScrollIndicator={false}
        renderItem={({ item, index }) => {
          return (
            <ProductCard
              partnerId={item?.partnerId}
              isRecommendationFlow={true}
              isInEligible
              reason={item?.reason}
              criteria={item?.criteria}
              key={index}
              index={index}
              route={route}
            />
          )
        }}
      />
    </Stack>
  )
}

export { InEligibleBrandsList }
